import axios from 'axios';
import { ErrorWithData } from '../error/ErrorWithData';
import { baseUri } from './baseUri';
import { BaseApiResponse } from './types/BaseApiResponse';

export const getApiData = async <T extends BaseApiResponse>(path: string): Promise<T> => {
    const url = new URL(path, baseUri).href;

    const response = await axios.get(url, {
        withCredentials: true,
    });
    if (response.status === 200) {
        return response.data as T;
    } else {
        throw new ErrorWithData(response, 'failed');
    }
};
